import { Component } from "@angular/core";

@Component({
  selector: "ab-spinner-inline",
  templateUrl: "./spinner-inline.component.html",
})
export class SpinnerInlineComponent {}
